/*[2/24/22, PC_DP_06, Priyanka D]*/
import * as SDISVC from '../SDIService';
import SDIConstants from '../SDIConstants';
import { Dispatcher } from 'simplr-flux';
import * as CookieService from '../CookieService';
import * as $ from 'jquery';
import * as MenuAction from './MenuAction';

const tokenExpired = async () => {
    try {
        let tokenExpiredData = { type: "Token_Expired", response: true };
        Dispatcher.dispatch(tokenExpiredData);

    } catch (ex) {
        console.log(ex)

    }
};
/*[05/18/22,WW-404_09], Priyanka D */
const Pageload = async (PageloadBO) => {
    try {
        SDISVC.callSecureGateway(
            SDIConstants.moduleNames.ReprintPackingSlips,
            SDIConstants.methodNames.ReprintPackingSlips_Pageload,
            JSON.stringify(PageloadBO),
            (data) => {
                if (data.success) {
                    if (data.response != "" && data.response) {
                        let contentData = { type: "OrderNumLoad", response: data.response };
                        Dispatcher.dispatch(contentData);
                    }
                } else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            MenuAction.tokenExpired();
                        }
                    }
                }
            });

    } catch (ex) {
        console.log(ex)
    }
};
const PickDate = (pickDateBO) => {
    try {
        ;
        SDISVC.callSecureGateway(
            SDIConstants.moduleNames.ReprintPackingSlips,
            SDIConstants.methodNames.ReprintPackingSlips_PickDate,
            JSON.stringify(pickDateBO),
            (data) => {
                if (data.success) {
                    
                    if (data.response != "" && data.response) {
                        let contentData = { type: "PickDateResponse", response: data.response };
                        Dispatcher.dispatch(contentData);
                    }
                }
                else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            tokenExpired();
                        }
                    }
                }
            });
    } catch (ex) {
        console.log(ex)
    }
}
const insertFavPage = async (insertFavPageBO) => {
    try {
        SDISVC.callSecureGateway(
            SDIConstants.moduleNames.Menu,
            SDIConstants.methodNames.Menu_InsertFavPage,
            JSON.stringify(insertFavPageBO),
            (data) => {
                if (data.success) {
                    if (data.response != "" && data.response) {
                        let contentData = { type: "NOTIFY_InsertFavPage", response: data.response };
                        Dispatcher.dispatch(contentData);
                    }
                } else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            MenuAction.tokenExpired();
                        }
                    }
                }
            });

    } catch (ex) {
        console.log(ex)
    }
};
const deleteFavPage = async (deleteFavPageBO) => {
    try {
        SDISVC.callSecureGateway(
            SDIConstants.moduleNames.Menu,
            SDIConstants.methodNames.Menu_DeleteFavPage,
            JSON.stringify(deleteFavPageBO),
            (data) => {
                if (data.success) {
                    if (data.response != "" && data.response) {
                        let contentData = { type: "NOTIFY_DeleteFavPage", response: data.response };
                        Dispatcher.dispatch(contentData);
                    }
                } else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            MenuAction.tokenExpired();
                        }
                    }
                }
            });

    } catch (ex) {
        console.log(ex)
    }
};
const Reprint = (pickDateBO) => {
    try {
        ;
        SDISVC.callSecureGateway(
            SDIConstants.moduleNames.ReprintPackingSlips,
            SDIConstants.methodNames.ReprintPackingSlips_Reprint,
            JSON.stringify(pickDateBO),
            (data) => {
                if (data.success) {
                    
                    if (data.response != "" && data.response) {
                        let contentData = { type: "Reprint", response: data.response };
                        Dispatcher.dispatch(contentData);
                    }
                }
                else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            tokenExpired();
                        }
                    }
                }
            });
    } catch (ex) {
        console.log(ex)
    }
};
const getCurrentFavPage = async (getFavPageBO) => {
    try {
        SDISVC.callRecurringGateway(
            SDIConstants.moduleNames.Menu,
            SDIConstants.methodNames.Menu_GetCurrentFavPage,
            JSON.stringify(getFavPageBO),
            (data) => {
                if (data.success) {
                    if (data.response != "" && data.response) {
                        let contentData = { type: "NOTIFY_CurrentFavPage", response: data.response };
                        Dispatcher.dispatch(contentData);
                    }
                } else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            MenuAction.tokenExpired();
                        }
                    }
                }
            });

    } catch (ex) {
        console.log(ex)
    }
};
const ReportDownload = (BO) => {
    try {
        ;
        SDISVC.downloadFile(
            SDIConstants.moduleNames.ReprintPackingSlips,
            SDIConstants.methodNames.ReprintPackingSlips_ReportDownload,
            JSON.stringify(BO),
            BO.filenameBO,
            (data) => {
                if (data.success) {
                    if (data.response != "" && data.response) {
                        ;
                        let contentData = { type: "Report", response: data.response };
                        Dispatcher.dispatch(contentData);
                    }
                }
            });
    } catch (ex) {
        console.log(ex)
    }
}
const ReportDownload1 = async (downloadBO) => {
    try {
        SDISVC.downloadFile(
            SDIConstants.moduleNames.NonCatalog,
            SDIConstants.methodNames.NonCatalog_DownloadFile,
            JSON.stringify(downloadBO),
            downloadBO.fileName,
            (data) => {
                if (data.success) {
                    $(`#${SDIConstants.SDILoader}`).addClass('hide');
                }
            });
    } catch (ex) {
        console.log(ex)
    }
};
export { PickDate, Reprint, getCurrentFavPage, deleteFavPage, insertFavPage, ReportDownload, ReportDownload1, Pageload }